export const VERSION_INFO = {
  version: '20261020.1',
  buildId: '459',
  commitHash: '39e9c22',
  buildDate: '2026-10-20 13:59:56 UTC',
  environment: 'Production'
};
